import {
  shiftStatsContract,
  type ShiftStatsQuery,
  type ShiftStatsResponse,
} from "@clipboard-health/contract-worker-app-bff";

export const getShiftsStatsRequestSchema = shiftStatsContract.getShiftStats.query;

export type GetShiftsStatsRequest = ShiftStatsQuery;

const { 200: getShiftsStatsResponseSchema } = shiftStatsContract.getShiftStats.responses;
export { getShiftsStatsResponseSchema };

export type GetShiftsStatsResponse = ShiftStatsResponse;

export type QualificationCount = NonNullable<
  ShiftStatsResponse["data"]["attributes"]["qualificationCounts"]
>[number];
